"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentValuesAsTabList = void 0;
const tslib_1 = require("tslib");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelValueSorting_1 = require("../LabelValueSorting");
const LabelDialogStateHelpers_1 = require("./LabelDialogStateHelpers");
const LabelsDialogContexts_1 = require("./LabelsDialogContexts");
function useCurrentValuesAsTabList() {
    const { initialValues, values } = (0, LabelsDialogContexts_1.useLabelDialogState)();
    const categoryWithValues = react_1.default.useMemo(() => Object.fromEntries(Object.entries(initialValues).map(([category, values]) => [category, (0, LabelDialogStateHelpers_1.sortValueDetails)(category, Object.keys(values !== null && values !== void 0 ? values : {}))])), [
        initialValues,
    ]);
    const state = (0, LabelsDialogContexts_1.useLabelDialogControlsState)();
    switch (state.kind) {
        case 'all':
            return allTabList(categoryWithValues);
        case 'applied':
            return appliedTabList(values);
        case 'category':
            return singleCategoryTabList(categoryWithValues, state.category);
        case 'filter':
            return filteredTabList(categoryWithValues, state.filter);
        default:
            (0, vizportalclient_common_components_1.assertUnreachable)(state);
            return [];
    }
}
exports.useCurrentValuesAsTabList = useCurrentValuesAsTabList;
function allTabList(initialValues) {
    return (0, LabelValueSorting_1.sortCategories)(Object.keys(initialValues)).flatMap(category => { var _a; return (0, LabelDialogStateHelpers_1.sortValueDetails)(category, (_a = initialValues[category]) !== null && _a !== void 0 ? _a : []).map((value, i) => ({ category, value, first: i === 0 })); });
}
function singleCategoryTabList(initialValues, category) {
    var _a;
    const filtered = { [category]: (_a = initialValues[category]) !== null && _a !== void 0 ? _a : {} };
    return allTabList(filtered);
}
function appliedTabList(values) {
    const active = Object.entries(values !== null && values !== void 0 ? values : {}).reduce((acc, [category, vs]) => {
        const filtered = Object.entries(vs !== null && vs !== void 0 ? vs : {}).filter(([_, l]) => !!l.active).map(([v]) => v);
        if (filtered.length > 0) {
            return Object.assign(Object.assign({}, acc), { [category]: filtered });
        }
        return acc;
    }, {});
    return allTabList(active);
}
function roughlyContains(str, filter) {
    return str.toLocaleLowerCase().includes(filter.toLocaleLowerCase());
}
function filteredTabList(initialValues, filter) {
    const filtered = Object.entries(initialValues).reduce((acc, [category, values]) => {
        const vs = values.filter(v => roughlyContains(v, filter));
        if (vs.length > 0) {
            return Object.assign(Object.assign({}, acc), { [category]: vs });
        }
        return acc;
    }, {});
    return allTabList(filtered);
}
//# sourceMappingURL=useCurrentValuesAsTabList.js.map